export const VISUAL_SHOVELER = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.VisualShovelerWidgetElement';
